/**
 * Aceleres -- texto puro colado no compositor, e o que sai dele.
 *
 * Duas metades do mesmo caminho:
 *
 * 1. O ProseMirror, quando cola texto sem HTML, faz
 *    `text.split(/(?:\r\n?|\n)+/)` e transforma CADA corte num parágrafo. Como
 *    o `+` engole a sequência inteira, uma quebra simples e três linhas em
 *    branco viram exatamente a mesma coisa: um parágrafo novo, que o
 *    serializador escreve como `\n\n`. Ou seja, colar ganhava linhas em branco
 *    onde não havia e perdia as que havia. No WhatsApp o texto colado fica
 *    igual ao original, e é isso que se reproduz aqui: uma quebra colada é uma
 *    quebra, nem mais nem menos.
 *
 * 2. O serializador de markdown escreve a quebra de linha como `\` + nova
 *    linha (a sintaxe de hard break do markdown). O Chatwoot renderiza isso
 *    como <br> e o atendente nunca vê a barra — mas o WhatsApp recebe o texto
 *    CRU, sem conversão nenhuma no caminho, e o contato vê a `\` no fim de
 *    cada linha. Por isso a barra sai na saída do editor.
 */

/** Uma quebra por `\n`, com `\r\n` e `\r` normalizados antes. */
export const plainTextLines = text =>
  String(text ?? '')
    .replace(/\r\n?/g, '\n')
    .split('\n');

/**
 * Insere o texto na transação preservando cada quebra como um `hard_break`.
 * Devolve a própria transação para quem for despachar.
 */
export const insertPlainTextPreservingBreaks = (tr, schema, text) => {
  const hardBreak = schema.nodes.hard_break;

  plainTextLines(text).forEach((line, index) => {
    if (index && hardBreak) {
      tr.replaceSelectionWith(hardBreak.create(), false);
    }
    if (line) tr.insertText(line);
  });

  return tr;
};

/**
 * Tira a `\` que o markdown usa para marcar quebra de linha, sem tocar numa
 * barra que o próprio texto tem: o par `\\` (barra literal escapada) é
 * consumido inteiro antes de a busca chegar à quebra seguinte.
 */
export const stripMarkdownHardBreaks = markdown =>
  String(markdown ?? '').replace(/\\\\|\\\n/g, match =>
    match === '\\\n' ? '\n' : match
  );
